import { render, staticRenderFns } from "./dormSignin.vue?vue&type=template&id=78ca1204&scoped=true"
import script from "./dormSignin.vue?vue&type=script&lang=js"
export * from "./dormSignin.vue?vue&type=script&lang=js"
import style0 from "./dormSignin.vue?vue&type=style&index=0&id=78ca1204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ca1204",
  null
  
)

export default component.exports